// Analytics event types for Google Analytics integration
export type AnalyticsEvent =
  | "demo_popup_opened"
  | "demo_form_submitted"
  | "demo_form_success"
  | "demo_form_error"
  | "callback_popup_opened"
  | "callback_form_submitted"
  | "callback_request"
  | "callback_form_error"
  | "cta_clicked"
  | "feature_clicked"
  | "special_popup_triggered"
  | "special_demo_form_submitted"
  | "special_demo_form_success"
  | "special_demo_form_error"
  | "audit_form_submitted"
  | "audit_form_success"
  | "audit_form_error";

export interface AnalyticsEventData {
  event: AnalyticsEvent;
  category?: string;
  label?: string;
  value?: number;
  [key: string]: unknown;
}

/**
 * Track analytics events
 * This function pushes events to the dataLayer for Google Tag Manager
 * or directly to gtag if available
 */
export function trackEvent(data: AnalyticsEventData): void {
  if (typeof window === "undefined") return;

  const { event, category, label, value, ...rest } = data;

  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // Push to dataLayer for GTM
  window.dataLayer.push({
    event,
    eventCategory: category,
    eventLabel: label,
    eventValue: value,
    ...rest,
  });

  // Also push to gtag if available
  if (typeof window.gtag === "function") {
    window.gtag("event", event, {
      event_category: category,
      event_label: label,
      value,
      ...rest,
    });
  }
}

// Extend Window interface for TypeScript
declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
  }
}
